<template>
    <ur-modal ref="modal" class="frame_terms_modal" :title="title" large >
        <div class="terms_version" align="right">
            <ur-dropdown ref="version" style="width: 200px;" v-model="versionValue" :items="dropdownItems" @input="onSelectVersion"/>
        </div>
        <div v-html="modifiedHtml" class="terms_content"/>
        <template #action>
            <ur-button solid primary @click="close()" text="확인"/>
        </template>
    </ur-modal>
</template>
<script>
import replaceBodyTagWithDivTag from '~common/js/html-util.js';

export default {
    name:'servicePersonalInfoModal',
    props:{
        title:{type:String, required:true, default:'',},
        contents:{type:String, required:true, default:'',},
        oldTermsNoticeList:{type:Array, required:true, default:'',},
    },
    data(){
        return{
            versionValue : '',
            oldTermsMap : new Map(),
            selectedTerms : '',
        }
    },
    created(){},
    mounted(){},
    computed:{
        dropdownItems(){
            var items = [];
            for (var i in this.oldTermsNoticeList) {
                const date = this.oldTermsNoticeList[i].displayStartDtm;
                date = date.substr(0, 4) + '.' + date.substr(4, 2) + '.' + date.substr(6, 2);
                const itemTitle = '[Ver ' + this.oldTermsNoticeList[i].termsVersion + '] ' + date;
                items.push(itemTitle);
                this.oldTermsMap.set(itemTitle, this.oldTermsNoticeList[i].termsContent);
            }
            return items;
        },
        modifiedHtml() {
            return replaceBodyTagWithDivTag(this.selectedTerms);
        },
    },
    methods:{
        open(){
            this.selectedTerms = this.contents;
            this.$refs['modal'].open();
        },
        close(){
            this.$refs['modal'].close();
        },
        onSelectVersion(v) {
            this.selectedTerms = this.oldTermsMap.get(v);
        },
    },
}
</script>
<style scoped>
    .terms_content {
        max-height: 568px;
        background-color: #fff;
        word-break: keep-all;
        overflow: auto;
        border: 1px solid #dbdbdb;
        padding:20px;
        line-height: 24px;
        font-family: 'NotoSansCJKkr';
    }
    ::v-deep .terms_content > ol {margin-left: 10px}
    ::v-deep .terms_content > ol > li {text-indent: -15px; padding-left: 15px;}
    ::v-deep .terms_content > ol > li > dd {text-indent: -10px; padding-left: 15px;}
    ::v-deep .terms_content > h4 {font-weight: 700;}
    ::v-deep .terms_content > dd {text-indent: -10px; padding-left: 15px;}
    ::v-deep .terms_content > .tb_pv {
        width: 100%;
        border-collapse: collapse;
        border:unset;
        border-top:1px solid #656b7e; 
        border-bottom: 1px solid #eaeaea;
        color: #000;
        line-height: 16px;
        margin-top: 5px;
        margin-left: 5px;
    }
    ::v-deep .terms_content > .tb_pv > .blind {display: none;}
    ::v-deep .terms_content > .tb_pv > thead {border-bottom: 1px solid #A5A5A5;}
    ::v-deep .terms_content > .tb_pv > thead > tr > th {
        height: 48px;
        padding: 5px 16px; 
        border:unset; 
        text-align: left;
        font-family: 'NotoSansCJKkr'; 
        font-weight:500; 
        color: #333; 
        line-height: 16px; 
        background: #f8f9fd;
    }
    ::v-deep .terms_content > .tb_pv > tbody > tr > th {
        padding: 5px 16px;
        border:unset;
        border-top:1px solid #eaeaea;
        text-align: left;
        font-family: 'NotoSansCJKkr';
        color: #333;
        line-height: 16px;
    }
    ::v-deep .terms_content > .tb_pv > tbody > tr > td {
        height: 48px;
        padding: 5px 16px;
        border:unset;
        border-top: 1px solid #eaeaea;
        text-align: left;
        font-family: 'NotoSansCJKkr';
        color: #333;
        line-height: 16px;
    }
</style>